import { CommonModule } from '@angular/common';
import type { OnInit } from '@angular/core';
import { Component, computed, inject, input } from '@angular/core';
import { InnogyComponentRendering } from '@core/jss-models';
import { JssPlatformService } from '@core/jss-platform';
import { getFieldValue } from '@core/jss-utils';
import { Status } from '@essent/common';
import { EnergyType } from '@essent/new-customer';
import {
  getMockOffer,
  getMockOfferOverview,
  mockConsumptionValues,
} from '@innogy/become-a-customer/offer';
import type {
  ConsumptionValuesVM,
  Offer,
  OfferOverview,
} from '@innogy/become-a-customer/shared/interfaces';
import {
  getCalculateExistingCustomer,
  getConsumptionValuesVM,
  getElectricityOverview,
  getGasOverview,
  getPropositionDuration,
  getPropositionOffer,
  getPropositionOfferStatus,
  initOrderAction,
  setBACFunnelStepAction,
} from '@innogy/become-a-customer/state';
import { showAomModalAction } from '@contracting/modals';
import { Store } from '@ngrx/store';
import { RoundedCurrencyPipe } from '@innogy/utils-deprecated';
import { JssModule } from '@sitecore-jss/sitecore-jss-angular';

import { OrderFulfillmentContainerComponent } from '../order-fulfillment-container/order-fulfillment-container.component';

@Component({
  selector: 'wl-order-container',
  templateUrl: './order-container.component.html',
  styleUrls: [
    './order-container.component.essent.scss',
    './order-container.component.ed.scss',
  ],
  standalone: true,
  imports: [CommonModule, OrderFulfillmentContainerComponent, JssModule],
  providers: [RoundedCurrencyPipe, JssPlatformService],
})
export class OrderContainerComponent implements OnInit {
  readonly store$ = inject(Store);
  readonly jssPlatformService = inject(JssPlatformService);

  readonly rendering = input.required<InnogyComponentRendering>();
  readonly context = input<any>();

  offerStatus = this.store$.selectSignal(getPropositionOfferStatus);
  duration = this.store$.selectSignal(getPropositionDuration);
  consumptionValuesVM = this.store$.selectSignal(getConsumptionValuesVM);
  electricityOverview = this.store$.selectSignal(getElectricityOverview);
  gasOverview = this.store$.selectSignal(getGasOverview);
  existingCustomerChecked = this.store$.selectSignal(
    getCalculateExistingCustomer
  );

  readonly orderOverviewBottomMobile = computed(() =>
    getFieldValue(this.rendering(), 'OrderOverviewBottomMobile', false)
  );
  readonly offer = computed(() =>
    this.offerStatus() === Status.SUCCESS
      ? this.store$.selectSignal(getPropositionOffer)()
      : undefined
  );

  readonly outputs = {
    showTariffs: ($event: Offer) => this.openAomModal($event),
  };

  ngOnInit(): void {
    this.store$.dispatch(setBACFunnelStepAction({ step: 'Order' }));

    if (!this.existingCustomerChecked()) {
      this.store$.dispatch(initOrderAction());
    }
  }

  get xpMockOrder(): {
    offer: Offer;
    consumptionValuesVM: ConsumptionValuesVM;
    durationTitle: string;
    electricityOverview: OfferOverview;
    gasOverview: OfferOverview;
  } {
    return {
      offer: getMockOffer(),
      consumptionValuesVM: mockConsumptionValues,
      durationTitle: 'Maandelijks opzegbaar',
      electricityOverview: getMockOfferOverview(EnergyType.ELECTRICITY),
      gasOverview: getMockOfferOverview(EnergyType.GAS),
    };
  }

  openAomModal(offer: Offer) {
    this.store$.dispatch(
      showAomModalAction({
        offer,
        showFooter: false,
        rendering: this.rendering(),
        consumptionValuesVM: this.consumptionValuesVM(),
      })
    );
  }
}
